/* eslint-disable no-case-declarations */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unused-vars */
export const getWellOperationsNavigationState = (): WellOperationsNavigationState => {
    return {
        endHistory: false,
        wells: []
    }
}
export const reducer: WidgetReducerType<WellOperationsNavigationState, WellOperationsNavigationMessage> = (
    state = getWellOperationsNavigationState(),
    message
) => {
    if (!message) {
        return state
    }

    if (message.baseline && message.type !== 'event') {
        return state
    }

    switch (message.type) {
        case 'start':
            state = getWellOperationsNavigationState()
            break
        case 'event':
            const messageEvents = message?.events
            const wells =
                (messageEvents &&
                    messageEvents?.length > 0 &&
                    messageEvents[0]?.allocation?.reduce((acc, curr, idx) => {
                        const intervention = curr.interventions[0]
                        if (acc.length > 0 && acc?.filter(w => w?.wellId === intervention?.wellId).length) {
                            const temp = acc?.filter(w => w?.wellId === intervention?.wellId)[0]
                            temp?.interventions?.push(intervention)
                            const index = acc.indexOf(temp)
                            acc[index] = temp
                        } else {
                            acc.push({
                                wellId: intervention?.wellId,
                                wellName: intervention?.wellName,
                                begin: intervention?.begin,
                                end: intervention?.end,
                                interventions: curr.interventions
                            })
                        }

                        return acc
                    }, [])) ||
                []

            state = {
                ...state,
                wells: wells.map(e => e)
            }
            break
        case 'endHistory':
            state = {
                endHistory: true,
                wells: state.wells.slice()
            }
            break
        default:
            return state
    }

    return state
}
